import { useEffect, useState } from 'react'

interface CountdownTimerProps {
  initialTime: string
  onExpire?: () => void
  onClearSelection?: () => void
}

export const CountdownTimer = ({
  initialTime,
  onExpire,
  onClearSelection,
}: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<string>('')

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date()
      const expirationTime = new Date(
        new Date(initialTime).getTime() + 5 * 60 * 1000,
      )

      const diff = expirationTime.getTime() - now.getTime()

      if (diff <= 0) {
        setTimeLeft('00:00')
        onExpire?.()
        onClearSelection?.()
        return
      }

      const minutes = Math.floor(diff / (1000 * 60))
      const seconds = Math.floor((diff % (1000 * 60)) / 1000)
      setTimeLeft(
        `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
      )
    }

    calculateTimeLeft()
    const interval = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(interval)
  }, [initialTime, onExpire, onClearSelection])

  return <span>{timeLeft}</span>
}
